import { render, staticRenderFns } from "./StepNotEligiblePertussis.vue?vue&type=template&id=b3cf4672&"
import script from "./StepNotEligiblePertussis.vue?vue&type=script&lang=js&"
export * from "./StepNotEligiblePertussis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports